import { Document } from '@/lib/ai/vector-store';
import { SupabaseVectorStore } from '@/lib/ai/supabase-vector-store';
import { VectorStore } from '@/lib/ai/vector-store';

// Interface that both vector stores implement
export interface IVectorStore {
  addDocuments(documents: Omit<Document, 'embedding'>[]): Promise<void>;
  similaritySearch(query: string, topK?: number): Promise<Document[]>;
  loadTrainingData(text: string): Promise<void>;
  isReady(): boolean;
  getDocumentCount(): number;
  removeDocument(id: string): Promise<boolean> | boolean;
  getAllDocuments(): Promise<Document[]> | Document[];
  clearDocuments(): Promise<void> | void;
  isUsingEmbeddings(): boolean;
}

// Determine which vector store to use
// Use Supabase if available, otherwise fall back to in-memory
const useSupabase = import.meta.env.VITE_USE_SUPABASE_VECTOR_STORE === 'true';

// Export the appropriate vector store
export const vectorStore: IVectorStore = useSupabase 
  ? SupabaseVectorStore.getInstance() 
  : VectorStore.getInstance();

// Export a function to check if we're using Supabase
export const isUsingSupabase = () => useSupabase; 